export default "__VITE_ASSET__BAk5hU6T__"